import { connect } from 'react-redux';
import { ProductCardLayoutType } from '../../common/models/product';
import { getSelected } from '../../single-choice/utils/selection';
import { SMS } from '../../products';
import MainSms from './MainSms';
import SmallSms from './SmallSms';
import { jsx as _jsx } from "react/jsx-runtime";
const Sms = props => {
  switch (props.layoutType) {
    case ProductCardLayoutType.Small:
      return /*#__PURE__*/_jsx(SmallSms, {
        ...props
      });
    case ProductCardLayoutType.Main:
    default:
      return /*#__PURE__*/_jsx(MainSms, {
        ...props
      });
  }
};
const mapStateToProps = (state, _ref) => {
  let {
    form
  } = _ref;
  return {
    isSelected: getSelected(SMS.name, form)(state)
  };
};
export default connect(mapStateToProps)(Sms);
//# sourceMappingURL=Sms.js.map